var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'loader-wrap':true, 'show':_vm.showModal}},[_c('div',{staticClass:"loader-box"},[_c('i',{staticClass:"fa fa-spinner fa-spin"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.modalMessage))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e86dd8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partials/LoadingModal.vue
// module id = 1044
// module chunks = 0